import jss from 'jss';
import preset from 'jss-preset-default';
import $ from "jquery";
import "slick-carousel";
import {generateVectorPosition} from 'Client/utils/vector-position'
let widthDevice = window.innerWidth;
class WidgetCarouselHandlerClass extends elementorModules.frontend.handlers.Base {
    getDefaultSettings() {
        return {
            selectors: {
                slider: '.timeline-widget-ecf .slides',
                slider_item: "#timeline-section .slide-wrapper .slide",
                img:".timeline-widget-ecf .background-img-position .img-position-item",
            },
        };
    }
    getDefaultElements() {
        const selectors = this.getSettings('selectors');
        return {
            $slider: this.$element.find(selectors.slider),
            $slider_item: this.$element.find(selectors.slider_item),
            $img: this.$element.find(selectors.img),
        };
    }
    getWidth(element,width){
        jss.setup(preset())
        const styles = {
          width_process:{
              width:`${width}% !important`,
            }
          }
          
        const {classes} = jss.createStyleSheet(styles).attach()
        element.classList.add(classes.width_process)
    }
    changeStatusProcess(number,slick){
      let onProgress = number + 3;
      let loadProgress = (onProgress / slick.slideCount) * 100;
      return loadProgress;
    }
    startSlick(slider,lengthSliderItem,THIS,processBar){
        slider.on(
          "init",
          function (event, slick, currentSlide, nextSlide) {
            THIS.getWidth(processBar,THIS.changeStatusProcess(0,slick));
          }
        );
      }
      beforeChangeSlick(slider,lengthSliderItem,THIS,processBar){
        slider.on(
          "beforeChange",
          function (event, slick, currentSlide, nextSlide) {
            THIS.getWidth(processBar,THIS.changeStatusProcess(nextSlide,slick));
          }
        );
      }
    bindEvents() {
        const THIS = this;
        let maxHeight = 0;
        let slider = $(this.elements.$slider[0]);
        let slider_item = $(this.elements.$slider_item);
        let img = $(this.elements.$img)
        let lengthSliderItem = slider_item.length;
        let processBar = document.querySelector(
            ".progress .progress-bar"
          );
          if(img.length>0){
            img.each(function(index, element){
              let obj = JSON.parse(element.getAttribute('att-position-img'));
              let responsive = JSON.parse(atob(element.getAttribute('att-responsive')))
              generateVectorPosition(obj,responsive,element);
            });
          }
          
        // slide[slide.length - 1].childNodes[1].classList.add('no-width');
        if (slider) {
            
            if(widthDevice >= 768){
                THIS.startSlick(slider,lengthSliderItem,THIS,processBar)
              }
              if(widthDevice >= 768){
                THIS.beforeChangeSlick(slider,lengthSliderItem,THIS,processBar);
              }
              $( window ).resize(function() {
                let widthResize = window.innerWidth;
                if(widthResize >= 768){
                  THIS.beforeChangeSlick(slider,lengthSliderItem,THIS,processBar);
                }
              });
            slider.slick({
                // initialSlide: 1,
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                variableWidth: true,
                nextArrow:
            '<button type="button" class="slick-next ecf-slider-arrow ecf-slider-arrow-slide-next">Next</button>',
            prevArrow:
            '<button type="button" class="slick-prev ecf-slider-arrow ecf-slider-arrow-slide-prev">Previous</button>',
                dots: false,
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            variableWidth: false,
                            nextArrow: false,
                            prevArrow: false,
                            // centerMode: false,
                            // centerPadding: "32px",
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1,
                          variableWidth: false,
                          centerMode: true,
                          centerPadding: "64px",
                            dots: true,
                            nextArrow: false,
                            prevArrow: false,
                        },
                    }
                  
                ],
            });
            
        }
    }
}

jQuery(window).on('elementor/frontend/init', () => {
    const addHandler = ($element) => {
        elementorFrontend.elementsHandler.addHandler(WidgetCarouselHandlerClass, {
            $element,
        });
    };

    elementorFrontend.hooks.addAction('frontend/element_ready/ecf_timeline_carousel.default', addHandler);
});